import { PaymentMethod } from './PaymentMethod';
import { PaymentCondition } from './PaymentCondition';
import { Client } from './Client';
import { Currency } from './Currency';
import { Society } from './Society';
import { Quote } from './Quote';
import { Unit } from './Unit';
import { WarehouseQuoteDetail } from './WareHouseQuoteDetail';
import { WarehouseOrderItemStatus } from './WarehouseOrderItemStatus';
import { Service } from './Service';
import { Product } from './Product';
export interface WarehouseOrderItem {
    id?: number;
    contactEmail?: string;
    status?: number | string;
    // statusSelected?: WarehouseOrderItemStatus;
    // statusChoices?: WarehouseOrderItemStatus[];
    expiredAt?: Date | string;
    clientId?: number;
    client?: Client
client_name?: string;
client_fantasy_name?: string;
    quoteId?: number;
    quote?: Quote;
    paymentMethodId?: number;
    paymentMethod?: PaymentMethod;
    paymentConditionId?: number;
    paymentCondition?: PaymentCondition;
    currencyId?: number;
    currency?: Currency;
    societyId?: number;
    society?: Society
society_name?: string;
society_fantasy_name?: string;
    createdAt?: Date | string;
    updatedAt?: Date | string;
    // warehouseOrderItemItems?: WarehouseOrderItemItems[];
}

export interface WarehouseOrderItemFilters {
    warehouse_order_status?: string | null;
    start_date?: string;
    end_date?: string;
    warehouse_order_id?: number;
    client?: string;
    quote_id?: number;

    page?: number;
    per_page?: number;
    sort?: string;
    order?: string;
}

export interface WarehouseOrderItemDataForm {
    id?: number;
    contact_email?: string;
    warehouse_order_id?: number;
    order_id?: number;
    expired_at?: string;
    expired_in_days?: number;
    client_id: number | string;
    warehouse_quote_detail_id?: number;
    warehouse_quote_detail?: WarehouseQuoteDetail;
    payment_method_id: number | string;
    payment_method?: string;
    payment_condition_id: number | string;
    // currency?: Currency | string;
    client?: string;
    society?: string;
    payment_condition?: string;
    reference?: string;
    days_count?: number;
    currency_id: number | string;
    society_id: number | string;
    status?: string;
    status_selected?: WarehouseOrderItemStatus;
    // status_choices?: WarehouseOrderItemStatusRequestDataForm[];
    // warehouse_order_details?: WarehouseOrderItemDetailDataForm[];
    created_at?: string;
    created_user?: string;
    updated_at?: string;
    last_modified_user?: string;
    rate_runner?: number;
    currency_rate_runner?: Currency;
    currency_rate_runner_id?: number;
    quantity_unit_rate_runner?: Unit;
    quantity_unit_rate_runner_id?: number;
    rate_transporter?: number;
    currency_rate_transporter?: Currency;
    currency_rate_transporter_id?: number;
    quantity_unit_rate_transporter?: Unit;
    quantity_unit_rate_transporter_id?: number;
    society_name?: string;
    client_name?: string;

    quota_date?: string;            // Fecha cuota
    // product?: string;               // Producto
    quantity?: number;              // Cantidad
    quantity_unit?: string;         // Unidad de cantidad
    warehouse?: string;             // Almacén
    unit_price?: number;            // Precio unitario de venta
    currency?: string;              // Moneda de venta
    sale_unit?: string;             // Unidad de venta
    comment?: string;   
    
    rate_unit_id?: number | string;
    rate_unit?: string;// Comentario adicional


    service?: Service
    
    service_id?: number;
    
    product_id: number;
    product?: Product;

    quantity_unit_id?: number | string;

    depot_id?: number;
    free_days?: number;

    container_entry_fee?: number;      // Tarifa por ingreso del contenedor
    daily_storage_fee?: number;        // Tarifa por día de almacenaje
    container_exit_fee?: number;       // Tarifa por salida del contenedor

    container_entry_fee_unit_id?: number;      // Tarifa por ingreso del contenedor
    daily_storage_fee_unit_id?: number;        // Tarifa por día de almacenaje
    container_exit_fee_unit_id?: number;       // Tarifa por salida del contenedor

    container_entry_fee_currency_id?: number;      // Tarifa por ingreso del contenedor
    daily_storage_fee_currency_id?: number;        // Tarifa por día de almacenaje
    container_exit_fee_currency_id?: number;  

}
export interface WarehouseOrderItemCreateDataForm {
    quantity?: number;
    rate?: number;

    quantity_unit_id?: number;
    currency_id?: number | string;

    rate_runner?: number | string;
    currency_rate_runner_id?: number | string;
    quantity_unit_rate_runner_id?: number | string;
    rate_transporter?: number | string;
    currency_rate_transporter_id?: number | string;
    quantity_unit_rate_transporter_id?: number | string;

    route_id?: number;
    agreed_distance?: number;
}


export interface WarehouseOrderItemEditDataForm {
    quantity?: number;
    rate?: number;

    quantity_unit_id?: number;
    currency_id?: number | string;

    rate_runner?: number | string;
    currency_rate_runner_id?: number | string;
    quantity_unit_rate_runner_id?: number | string;
    rate_transporter?: number | string;
    currency_rate_transporter_id?: number | string;
    quantity_unit_rate_transporter_id?: number | string;

    route_id?: number;
    agreed_distance?: number;
}
// export interface WarehouseOrderItemDetailDataForm {
//     warehouse_order_id?: number;
//     id?: number;
//     description?: string;
//     first_dispatch_date: string;
//     product_name?: string;
//     product_rate?: number;
//     product_unit?: string;
//     quantity?: number | string;
//     rate?: number | string;
//     currency?: string;
//     service?: string;
//     service_id?: number | string;
//     destiny_id?: number | string;
//     origin_id?: number | string;
//     product_id?: number | string;
//     quantity_unit_id?: number | string;
//     currency_id?: number | string;
//     created_at?: string;
//     updated_at?: string;
// }

export interface WarehouseOrderItemShowDataForm {
    id?: number;
    quote_id?: number;

    quota_date?: string;            // Fecha cuota
    // product?: string;               // Producto
    quantity?: number;              // Cantidad
    quantity_unit?: string;         // Unidad de cantidad
    warehouse?: string;             // Almacén
    unit_price?: number;            // Precio unitario de venta
    currency?: string;              // Moneda de venta
    sale_unit?: string;             // Unidad de venta
    comment?: string;   
    
    rate_unit_id?: number | string;
    rate_unit?: string;// Comentario adicional

    created_at?: string;
    updated_at?: string;

    service?: string
    
    service_id?: number;
    currency_id?: number;
    
    product_id?: number;
    product?: string;

    quantity_unit_id?: number | string;

    depot_id?: number;
    depot?: string;
    free_days?: number;



    container_entry_fee?: number;      // Tarifa por ingreso del contenedor
    daily_storage_fee?: number;        // Tarifa por día de almacenaje
    container_exit_fee?: number;       // Tarifa por salida del contenedor


    container_entry_fee_unit?: string;      // Tarifa por ingreso del contenedor
    daily_storage_fee_unit?: string;        // Tarifa por día de almacenaje
    container_exit_fee_unit?: string;       // Tarifa por salida del contenedor

    container_entry_fee_currency?: string;      // Tarifa por ingreso del contenedor
    daily_storage_fee_currency?: string;        // Tarifa por día de almacenaje
    container_exit_fee_currency?: string;       // Tarifa por salida del contenedor
}

// export interface WarehouseOrderItemRatesDataForm {
//     rate_runner?: number | string;
//     currency_rate_runner?: string;
//     quantity_unit_rate_runner?: string;
//     rate_transporter?: number | string;
//     currency_rate_transporter?: string;
//     quantity_unit_rate_transporter?: string;
// }

// export interface WarehouseOrderItemStatusRequestDataForm {
//     id: number | string;
//     name: number | string;
// }

export const defaultWarehouseOrderItemDataForm: WarehouseOrderItemDataForm = {
    contact_email: '',
    expired_at: '',
    expired_in_days: 0,
    client_id: 0,
    payment_method_id: 0,
    payment_condition_id: 0,
    reference: '',
    days_count: 0,
    currency_id: 0,
    society_id: 0,
    status: '',
    product_id: 0,

};



export const defaultWarehouseOrderCreateItemDataForm: WarehouseOrderItemCreateDataForm = {
    rate: 0,
    quantity_unit_id: 0,
    currency_id: 0,
    rate_runner: 0,
    rate_transporter: 0
};


export const defaultWarehouseOrderEditItemDataForm: WarehouseOrderItemEditDataForm = {
    quantity_unit_id: 0,
    currency_id: 0,
    quantity: 0,

};
// export const defaultWarehouseOrderItemRateDataForm: WarehouseOrderItemRatesDataForm = {
//     rate_runner: 0,
//     currency_rate_runner: '',
//     quantity_unit_rate_runner: '',
//     rate_transporter: 0,
//     currency_rate_transporter: '',
//     quantity_unit_rate_transporter: ''
// };
